import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { graphql } from '@graphql/gql/gql';

export const LOG = LoggerFactory.create('getSubscriptionToken');

const SUBSCRIPTION_TOKEN = graphql(`
  mutation subscriptionToken {
    subscriptionToken {
      token
    }
  }
`);

export const getSubscriptionToken = async (apolloClient: ApolloClient<NormalizedCacheObject>): Promise<string> => {
  const { data } = await apolloClient.mutate({
    mutation: SUBSCRIPTION_TOKEN
  });

  return data?.subscriptionToken?.token;
};
